import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import store from '../store'
import router from '../router'

// const API_DOMAIN = 'http://localhost:8080'
const API_DOMAIN = ''
const API_URL = API_DOMAIN + '/api'

const plainAxiosInstance = axios.create({
  baseURL: API_URL
})

const securedAxiosInstance = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded'
  }
})

securedAxiosInstance.interceptors.request.use(config => {
  const method = config.method.toUpperCase()
  if (method !== 'OPTIONS' && method !== 'GET') {
    config.headers = {
      ...config.headers
    }
  }
  return config
})

securedAxiosInstance.interceptors.response.use(null, error => {
  if (error.response && error.response.config && error.response.status === 401) {
    store.commit('unsetCurrentUser')

    if(Object.prototype.hasOwnProperty.call(error.response.data, 'error')){
      if(error.response.data.error == 'Invalid username or password.'){
        return Promise.reject(error)
      }
    }

    router.push({ name: 'login' })
    // window.location.href = APP_LOGIN_URL
  } else {
    return Promise.reject(error)
  }
})

plainAxiosInstance.interceptors.response.use(null, error => {
  if (error.response && error.response.config && error.response.status === 401) {
    store.commit('unsetCurrentUser')
    router.push({ name: 'login' })
    // window.location.href = APP_LOGIN_URL
  } else {
    return Promise.reject(error)
  }
})


Vue.use(VueAxios, { plain: plainAxiosInstance, secured: securedAxiosInstance })
